import React from 'react'
import Card from 'react-bootstrap/Card'
import Row from 'react-bootstrap/Row'
import InputGroup from 'react-bootstrap/InputGroup'
import { Button, Image } from 'react-bootstrap'
import { FormikControl } from '@stem-sims/nexus'
import { useFormikContext } from "formik"
import stringToFloat from '../../helpers/stringToFloat'

type PriceCardProps = {
    color: string
    icon: string
    title: string
    price: string
    priceUnit: string
    features: string[]
    hasInput?: boolean
    name?: string
}

function PriceCard(props: PriceCardProps) {
    return (<>
        <Card className={`${props.color} col-lg-5 price-card`}>
            <Card.Body className='d-flex flex-column justify-content-between'>
                <div>
                    <Row className='justify-content-between flex-nowrap'>
                        <div className={'d-inline col-7 align-items-center text-start g-0'}>
                            <Image className="d-inline me-1 pe-2" width={"50px"} height={"50px"}  src={props.icon} alt={props.title}/>
                            <h2 className="h4 d-inline-block mb-0"><strong>{props.title}</strong></h2>
                        </div>
                        <div className="col price text-end g-0">
                            <strong>
                                ${props.price}
                            </strong>
                            <span>
                            {props.priceUnit}
                            </span>
                        </div>
                    </Row>

                    <ul className="text-start mt-4 ms-n3">
                        {props.features.map((feature) => 
                            <li className={'font-light mb-3 pb-3'} key={feature}>{feature}</li>
                        )}
                    </ul>
                </div>
                <div>
                    <p className='text-center mt-2'>Contact us for group pricing at <br /><a href="tel:877-475-3277">877-475-3277</a></p>
                    {props.hasInput && <CardInput name={props.name} /> }
                </div>
            </Card.Body>
        </Card>
    </>)
}

function CardInput({ name } : { name: string }) {
    const { isSubmitting, setFieldValue, values } = useFormikContext()
    return (
        <Row className='justify-content-center mt-3'>
            <label id="student-licenses" className="col control-label text-center pe-md-3">Licenses</label>
            <InputGroup className="col">
                <Button
                    disabled={isSubmitting}
                    onClick={() => {
                        if(values[name] === 0) return
                        setFieldValue(name, values[name] - 1)
                    }}
                    variant='secondary'
                >
                    <i className='fa fa-minus' />
                </Button>
                <FormikControl
                    name={name}
                    aria-describedby="student-licenses"
                    className="text-center"
                    onBlur={() => {
                        let value = values[name]
                        if (typeof value === "string") {
                            value = Math.ceil(stringToFloat(value))
                        }
                        setFieldValue(name, value)
                    }}
                />
                <Button
                    disabled={isSubmitting}
                    onClick={() =>
                        setFieldValue(name, values[name] + 1)
                    }
                    variant='secondary'
                >
                    <i className='fa fa-plus' />
                </Button>
            </InputGroup>
        </Row>
    )
}

export default PriceCard;
